import { render, staticRenderFns } from "./UnitData.vue?vue&type=template&id=39ddc31c&scoped=true"
import script from "./UnitData.vue?vue&type=script&lang=js"
export * from "./UnitData.vue?vue&type=script&lang=js"
import style0 from "./UnitData.vue?vue&type=style&index=0&id=39ddc31c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ddc31c",
  null
  
)

export default component.exports